import React from "react"

class FormsDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    var form_type = ''
    if (this.props.row.forms && this.props.row.forms.length > 0) {
      var forms = this.props.row.forms.map((form)=>{
        if(form.form_type == 'order') {
           form_type = 'customer';
        } else if (form.form_type == 'document') {
           form_type = 'agreement';
        } else  {
           form_type = form.form_type;
        }
        return <li key={form.id}>{`${form.title}`}<i>{` (${I18n.t(form_type)})`}</i></li>  
      })

      return (
        <ul className="RoomTypesDataType">{forms}</ul>
      );
    } else {
      return <span className="none">{I18n.t('none')}</span>;
    }
  }
};

export default FormsDataType